import React, {useState, useEffect} from 'react';
import {useSelector, useDispatch} from 'react-redux';
import {useRouter} from 'next/router';
import ConsoHead from '../../../components/header/ConsoHead';
import ConsoNavbar from '../../../components/header/Navbar';
import {accountMenuList} from '../../../components/header/mainMenuList';
import Container from 'react-bootstrap/Container';
import AuthScreen from '../../../components/elements/AuthScreen';
import UserReviewList from '../../../components/review/account/UserReviewList';
import ManageReview from '../../../components/review/account/ManageReview';
import dynamic from 'next/dynamic';
const ConsoFooter = dynamic(() => import('../../../components/footer/ConsoSmallFooter'));
import withFullPopup from '../../../components/elements/withFullPopup';
import { loadCartFromStorage } from '../../../components/utils/general/cartUtils';
import { saveProducts } from '../../../components/cart/cartSlice';

const AccountReviewPage = (props) => {
    
    const seo  = {
        title: "Recenzii - Contul meu",
        description: "Recenzii cont Conso",
        canonical: `${process.env.NEXT_PUBLIC_SITE_URL}/user/recenzii`
    };

    const [isLoading, editIsloading] = useState(true);
    const closeLoading = () => { editIsloading(false)};
    const [action, editAction] = useState('list');
    const [currentReviewId, editCurrentReviewId] = useState(false);

    //redirect for logout
    const user = useSelector(state => state.user );
    const shoppingCart = useSelector(state => state.cart);
    const cart = shoppingCart.products;

    const router = useRouter();
    const dispatch = useDispatch();

    useEffect( ()=>{
            setupCart();
        }, []
    )

    useEffect( ()=>{
        if (user.status=='logout') {
            router.push('/login');
        }
    }, [user.status]
    )

    const loadingScreen = 
        <AuthScreen 
            message="Te rugăm să aștepți..." 
            closeLoading={closeLoading}
        />;

    const setupCart = () => {
        if (cart && cart.length == 0) {
            const storageData = loadCartFromStorage();
            if (storageData && storageData.products) {
                dispatch(saveProducts({ products: storageData.products, status: 'init'}));
            }
        }
    }

    const manageReview = (id) => {
        editAction('add');
        editCurrentReviewId(id);
    }

    const showList = () => editAction('list');
    const EditReview = withFullPopup(ManageReview);

    return (
        isLoading ?
        loadingScreen
        :
        <>
            <ConsoHead seo={seo}  />
            <ConsoNavbar 
                selected="Recenzii" 
                menu={accountMenuList} 
                cart={cart}
            />  
            <div className="mb-0 pb-0 bg-home" id="main" >
                <Container >
                    {action == 'list' && <UserReviewList manageReview={manageReview} /> }
                    {action == 'add' && 
                    <EditReview 
                        currentReviewId={currentReviewId} 
                        closePopup={showList}
                        showList={showList}
                        title="Recenzii" 
                    /> 
                    }
                </Container>
            </div>
            <ConsoFooter />
        </>
        
    );
}
export default AccountReviewPage;
